/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Table, Form } from 'react-bootstrap';
import FormGroupInput from '../../common/FormGroupInput'; // eslint-disable-next-line
import { copiriAxiosPost, copiriPortalRequest, copiriAxiosGet } from '../../api/api'; // eslint-disable-next-line
import config from '../../config/config'; // eslint-disable-next-line
import { toast } from 'react-toastify'; // eslint-disable-next-line
import { genPageData } from '../../langconfig/langconfig'; // eslint-disable-next-line
const MemberShipInformationModal = props => {
	const { type, modalHeadingText, pageLanguageContent, membershipData, profileId, updateData, officeRoles } = props;
	const [roles, setRoles] = useState([]); // eslint-disable-next-line
	const [roleHistory, setRoleHistory] = useState([]); // eslint-disable-next-line
	const [roleStatus, setRoleStatus] = useState([]);
	const [checkHistory, setCheckHistory] = useState(false);
	const [inputField, setInputField] = useState({
		number: '',
		is_admin: '',
		primary: '',
		office: '',
		status_id: ''
	});

	const [validation, setValidation] = useState({
		error_number: '',
		error_office: '',
		error_status_id: ''
	});

	const [date, setDate] = useState('');

	useEffect(() => {
		if (props.showHide) {
				
				const today = new Date();
				const yyyy = today.getFullYear();
				// Months are zero-indexed, add leading zero if needed
				const mm = String(today.getMonth() + 1).padStart(2, '0'); 
				const dd = String(today.getDate()).padStart(2, '0');
				let formattedDate = `${yyyy}-${mm}-${dd}`;

			setDate(formattedDate);
			var number = membershipData['member_number'];
			var status_id = String(membershipData['status_id']);
			let office = '';
			let role = membershipData['role'];
			if (officeRoles && officeRoles.length>0) {
				for (let i=0;i<officeRoles.length;i++) {
					if (officeRoles[i]['name'].toLowerCase()===role.toLowerCase()) {
						office= String(officeRoles[i]['id']);
					}
				}
			}

			setInputField({ ...inputField, number, status_id, office });
			setValidation([]);
			if (localStorage.getItem('active_profile_id')) {
				getRoleHistory(localStorage.getItem('active_profile_id'));
			}
			if (type && type === 'memberShipOffice') {
				if (officeRoles.length <= 0) {
					getRoles();
				} else {
					setRoles(officeRoles);
				}
			}
			if (type && type === 'memberShipStatus') {
				getStatus();
			}
		}
		// eslint-disable-next-line
	}, [props.showHide]);

	const getStatus = () => {
		copiriPortalRequest('/canon/types/status?existing=' + membershipData.status_id+'&membership_id='+membershipData.id, config.app_version, 'get')
			.then(response => {
				const result = Object.entries(response.data).map(([name, obj]) => ({ name, ...obj }));
				if (result && result.length > 0) {
					setRoleStatus(result);
				}
			})
			.catch(error => {});
	};

	const getRoleHistory = id => {
		copiriPortalRequest('/users/' + profileId + '/role/history', config.app_version, 'get')
			.then(response => {
				setCheckHistory(true);
				if (response.data.history.length > 0) {
					setRoleHistory(response.data.history);
				}
			})
			.catch(error => {
				setCheckHistory(false);
			});
	};

	const getRoles = () => {
		var org_id = localStorage.getItem('selected_org_id');
		copiriPortalRequest('/organizations/' + org_id + '/roles', config.app_version, 'get')
			.then(response => {
				if (response.data.length > 0) {
					setRoles(response.data);
				}
			})
			.catch(error => {});
	};

	const inputsHandler = e => {
		setInputField({ ...inputField, [e.target.name]: e.target.value });
	};

	function updateMembershipData() {
		let errors = { ...validation };
		var errorCount = 0;
		if (type === 'memberShipNumber') {
			if (!inputField.number.trim()) {
				errors.error_number = pageLanguageContent['PRL026'];
				errorCount++;
			} else {
				errors.error_number = '';
			}
		}
		if (type === 'memberShipStatus') {
			if (!inputField.status_id.trim()) {
				errors.error_status_id = pageLanguageContent['PRL026'];
				errorCount++;
			} else {
				errors.error_status_id = '';
			}
		}

		if (type === 'memberShipOffice') {
			if (!inputField.office.trim()) {
				errors.error_office = pageLanguageContent['PRL026'];
				errorCount++;
			} else {
				errors.error_office = '';
			}
		}
		setValidation(errors);
		var sendFormData = {};
		if (errorCount <= 0) {
			let returnData = '';
			if (type === 'memberShipNumber') {
				sendFormData['number'] = inputField['number'];
				returnData = inputField['number'];
			}
			if (type === 'memberShipStatus') {
				sendFormData['status_id'] = inputField['status_id'];
				returnData = inputField['status_id'];
			}
			if (type === 'memberShipOffice') {
				sendFormData['office'] = inputField['office'];
				if (officeRoles && officeRoles.length>0) {
					for (let i=0;i<officeRoles.length;i++) {
						if (parseInt(officeRoles[i]['id'])===parseInt(inputField['office'])) {
							returnData= officeRoles[i]['name'];
						}
					}
				}
			}
			let parentChild = 'parent';
			let orgId = membershipData['org_id'];
			if (membershipData['parent_id'] && membershipData['parent_id']!=='') {
				parentChild= 'child';
				orgId = membershipData['parent_id']
			}
			copiriPortalRequest(
				'/users/' + profileId + '/memberships/' + membershipData['id'],
				config.app_version,
				'patch',
				sendFormData
			)
				.then(response => {
					toast.success('Success');
					props.onClick();
					updateData(profileId, '', '', 'membership', membershipData['id'], returnData, orgId, type, parentChild);
					
				})
				.catch(error => {
					if (error.response.data.result){
						toast.error(error?.response?.data?.result);						
					} else {
						toast.error(genPageData['GENSWW']);
					}
				});
		} else {
		}
	}

	/* function to check the value of ordered date input box  */
	const onChangeDate = event => {
		setDate(event.target.value);
	};
	return (
		<>
			<Modal show={props.showHide} onHide={props.onClick} className='email_modal'>
				<ModalHeader
					onHide={props.onClick}
					style={{ backgroundColor: '#337ab7', border: '#337ab7' }}
					className='modalHeader'
				>
					<Modal.Title>{modalHeadingText}</Modal.Title>
				</ModalHeader>
				<ModalBody>
					<Row>
						<Col lg={12}>
							{type && type === 'memberShipNumber' && (
								<FormGroupInput
									id='MemebrshipNumber'
									label={pageLanguageContent['PRL123'] ? pageLanguageContent['PRL123'] : ''}
									type='text'
									name='number'
									onChange={inputsHandler}
									value={inputField.number}
								/>
							)}
							{validation.error_number && <p className='formValidationError'>{validation.error_number}</p>}

							{type && type === 'memberShipStatus' && (
								<Form.Group className='form-group'>
									<Form.Label for='officeName'>
										{pageLanguageContent['PRL125'] ? pageLanguageContent['PRL125'] : ''}
									</Form.Label>
									<select
										className='form-control decorated'
										onChange={inputsHandler}
										value={inputField.status_id}
										name='status_id'
									>
										<option value=''>Select Status</option>
										{roleStatus.length > 0 &&
											roleStatus.map((item, i) => (
												<option value={item.id} data-rc={item.id} key={i}>
													{item.name}
												</option>
											))}
									</select>
								</Form.Group>
							)}
							{validation.error_status_id && <p className='formValidationError'>{validation.error_status_id}</p>}
							{type && type === 'memberShipOffice' && (
								<><Form.Group className='form-group'>
									<Form.Label for='officeName'>
										{pageLanguageContent['PRL124'] ? pageLanguageContent['PRL124'] : ''}
									</Form.Label>
									<select
										className='form-control decorated'
										onChange={inputsHandler}
										name='office'
										value={inputField.office}
									>
										<option value=''>{pageLanguageContent['PRL100'] ? pageLanguageContent['PRL100'] : ''}</option>
										{roles.length > 0 &&
											roles.map((item, i) => (
												<option value={item.id} data-rc={item.id} key={i}>
													{item.name}
												</option>
											))}
									</select>
								</Form.Group>

								<Form.Group className='form-group'>
									<Form.Label for='officeDate'>
										{pageLanguageContent['PRL158'] ? pageLanguageContent['PRL158'] : ''}
									</Form.Label>
									<input
										type='date'
										placeholder=''
										value={date}
										className={'edit_user_dob form-control'}
										onChange={onChangeDate}
									/>										
								</Form.Group>
								</>							
							)}
							{validation.error_office && <p className='formValidationError'>{validation.error_office}</p>}
							{type && type === 'history' && (
								<Table
									striped
									className='table table-dashboard table-striped table-sm fs--1 border mb-0 table-dashboard-th-nowrap'
								>
									<thead className=''>
										<tr className='bg-200 text-900'>
											<th className='text-left pl-2'>{pageLanguageContent['PRL156'] ? pageLanguageContent['PRL156'] : ''}</th>
											<th className='text-left pl-2'>{pageLanguageContent['PRL157'] ? pageLanguageContent['PRL157'] : ''}</th>
										</tr>
									</thead>
									<tbody>
										{checkHistory && (
											<>
												{roleHistory.length > 0 ? (
													roleHistory.map((item, i) => (
														<tr key={i}>
															<td>{item['creator'] ? item['creator']['created'] : ''}</td>
															<td>{item['name']}</td>
														</tr>
													))
												) : (
													<tr>
														<td>{pageLanguageContent['PRL086'] ? pageLanguageContent['PRL086'] : ''}</td>
													</tr>
												)}
											</>
										)}
									</tbody>
								</Table>
							)}
						</Col>
					</Row>
				</ModalBody>
				<ModalFooter>
					{type && type !== 'history' && (
						<Button color='primary' onClick={updateMembershipData}>
							{genPageData['GENSAV'] ? genPageData['GENSAV'] : ''}
						</Button>
					)}
				</ModalFooter>
			</Modal>
		</>
	);
};
export default MemberShipInformationModal;
